import React from "react";
import SuccessIcon from "@app/ups/assets/svg/success_icon.svg";
import { Svg } from "@natera/material/lib/svg";

import "./successInfoBox.scss";

interface SuccessInfoBoxProps {
  title: string;
  description1: string;
  description2: string;
}

const SuccessInfoBox: React.FC<SuccessInfoBoxProps> = ({
  title,
  description1,
  description2,
}) => {
  return (
    <div className="ups-success-info-box">
      <Svg className="ups-success-info-box__icon" content={SuccessIcon} />
      <div className="ups-success-info-box__container">
        <h3 className="ups-success-info-box__container__title">{title}</h3>
        <p className="ups-success-info-box__container__description">
          {description1}
        </p>
        <p className="ups-success-info-box__container__description">
          {description2}
        </p>
      </div>
    </div>
  );
};

export default SuccessInfoBox;
